


























































































import {
  Vue,
  Prop,
  Component,
  Watch,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import moment from 'moment';
import ContractService from '@/domain/contract/service/contract.service';
import PushOrderPersist from '@/domain/contract/entity/push-order-persist.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';

@Component({
  components: {
    MainButton,
  },
})
export default class PushOrderModal extends Vue {
  @Prop({ required: true }) show!: boolean;

  @Prop({ required: true }) businessUnitId!: string;

  @Prop({ required: true }) contract!: Contract;

  rules: Rules = new Rules();

  $refs!: any;

  menuDataField: boolean = false;

  numberPushOrder: string = '';

  requestDate: string | null = null;

  minDateSolicitation: string = moment().format('YYYY-MM-DD');

  maxDateSolicitation: string = moment().add(24, 'months').format('YYYY-MM-DD');

  @Watch('show')
  onShowChanged() {
    this.numberPushOrder = this.contract.pushOrderNumber || '';
    this.requestDate = this.contract.pushOrderExpirationDate || null;
  }

  setRequestDateFormat(newFormat: string) {
    const parsed = moment(newFormat, 'DD/MM/YYYY', true);
    this.requestDate = parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
  }

  get requestDateFormat() {
    if (!this.requestDate) return '';
    if (moment(this.requestDate).isAfter(this.maxDateSolicitation)) {
      this.requestDate = this.maxDateSolicitation;
    }
    return moment(this.requestDate).isValid() ? moment(this.requestDate).format('DD/MM/YYYY') : '';
  }

  disableMonths(val): boolean {
    return this.disabledBeforeMonths(val);
  }

  disabledBeforeMonths(val) {
    return val >= moment().subtract(3, 'months').format('YYYY-MM').substr(0, 10);
  }

  clearRequestDate() {
    this.requestDate = '';
  }

  close() {
    this.$emit('cancel');
  }

  save() {
    if (!this.$refs.form.validate()) return;

    const pushOrder = new PushOrderPersist();
    pushOrder.numberPushOrder = this.numberPushOrder;
    pushOrder.datePushOrder = moment(this.requestDate).format('YYYY-MM-DD');

    ContractService.persistPushOrder(
      this.businessUnitId,
      this.contract.id,
      pushOrder,
    )
      .then(() => {
        VbSnackbarService.showSuccess('Ordem de Compra (Push Order) atualizada com sucesso!');
        this.$emit('refreshContract');
        this.close();
      })
      .catch((error) => VbSnackbarService.showError(error));
  }
}
